import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { icon, label } from "../../../config";

/**
 * adds "Show more" label in the "Detail" panel bar item
 * @author Muskan Thakur
 */
const CustomPanelBarItemContent = ({ title, showTaskDetailPanel, flowElementsSectionRef }) => {
  const { task } = useSelector((state) => state.taskSidebar);

  return (
    <div className='panel-bar-item' ref={flowElementsSectionRef}>
      <span>{title}</span>
      <span className='show-more-container'>
        {(title === label.DETAILS || title === label.APPROVAL) && !!showTaskDetailPanel && task?.taskId && (
          <span>
            <span className={`show-more `}>{label.SHOW_MORE}</span>
            <span>{icon.ARROW_DOWN}</span>
          </span>
        )}
      </span>
    </div>
  );
};

export default CustomPanelBarItemContent;
